export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const SET_USER_DATA = 'SET_USER_DATA';
export const AUTHENTICATION_ERROR = 'AUTHENTICATION_ERROR';
export const USER_TOKEN = 'token';
export const SET_BUNDLE = 'SET_BUNDLE';
